import { useNavigation } from "@react-navigation/native";
import { AHButton, AHText, Box } from "arkh";
import React from "react";

import { Platform } from "react-native";
import { useIntlTokens } from "../../../../../../components/mobile/useIntlTokens";
import { WACategoryNavigationProp } from "../../WANavigation";

export function WACategoryKPIEmpty() {
  const navigation = useNavigation<WACategoryNavigationProp<"WACategoryKPI">>();
  const intl_tokens = useIntlTokens();
  return (
    <Box
      style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
      spaceHorizontal="large"
    >
      <Box
        color="surface"
        cornerRadius="medium"
        space="medium"
        style={{ alignSelf: "stretch", alignItems: "center" }}
      >
        <AHText
          type="title"
          spaceBottom="small"
          style={{ alignItems: "center" }}
        >
          Kom igång med nyckeltal!
        </AHText>
        <AHText
          style={{ lineHeight: 17, fontSize: 13, textAlign: "center" }}
          color="darkText"
          spaceBottom="xxlarge"
        >
          Med Nyckeltal i StoreSprint kan ni följa upp och visualisera nyckeltal
          på ett enkelt sätt.
        </AHText>
        <AHButton
          themeType="primary"
          onPress={() => {
            if (Platform.OS === "android") {
              navigation.navigateDeprecated("StoreAdmin", {
                screen: "KPIAdmin",
                params: {
                  standalone: true,
                },
              });
              return;
            }
            const navigationType = navigation.getState().type;
            if (navigationType === "drawer") {
              navigation.pop();
            } else if (navigationType === "stack") {
              navigation.popToTop();
              navigation.goBack();
            }
            navigation.navigateDeprecated("StoreAdmin", {
              screen: "KPIAdmin",
              params: {
                standalone: true,
              },
            });
          }}
          title={intl_tokens.AdminKPI}
        />
      </Box>
    </Box>
  );
}
